import { action } from "./index";

export const SET_CHANNEL = "PLAYER/SET_CHANNEL";
export const setChannel = (channel, title = "") => action(SET_CHANNEL, { channel, title });

export const CLOSE = "PLAYER/CLOSE";
export const closePlayer = () => action(CLOSE);




// WEBPACK FOOTER //
// ./app/actions/playerActions.js